import { render } from "./GelombangPpdb.vue?vue&type=template&id=31f4df84"
import script from "./GelombangPpdb.vue?vue&type=script&lang=js"
export * from "./GelombangPpdb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__